import { ReportData } from './generatePdf';

export const generateCsvReport = (data: ReportData): Blob => {
    const rows = [
        ['Metric', 'Value'],
        ['Project', data.project.name],
        ['Version', data.project.version],
        ['Date', data.project.date],
        ['Commit', data.project.commit],
        ['Coverage', `${data.metrics.coverage}%`],
        ['Bugs', data.metrics.bugs.toString()],
        ['Technical Debt', data.metrics.technicalDebt],
    ];

    if (data.issues && data.issues.length > 0) {
        rows.push([]);
        rows.push(['Issues List']);
        rows.push(['Type', 'Severity', 'File', 'Line', 'Message']);
        data.issues.forEach(issue => {
            rows.push([
                issue.type,
                issue.severity,
                issue.file,
                issue.line.toString(),
                `"${issue.message.replace(/"/g, '""')}"` // Escape quotes for CSV
            ]);
        });
    }

    const csvContent = rows.map(e => e.join(",")).join("\n");
    return new Blob([csvContent], { type: 'text/csv' });
};
